import jsonPointer from 'json-pointer';
import isString from 'lodash/isString';
import { isRestrictedPathSegment } from './restrictedPathSegment';

const stripSegments = (segments) => {
  let strippedSegments = segments.slice();
  let indexOfRestricted = strippedSegments.findIndex(isRestrictedPathSegment);

  while (indexOfRestricted > -1) {
    const indexOfProperties = strippedSegments.indexOf('properties', indexOfRestricted);
    strippedSegments = [
      ...strippedSegments.slice(0, indexOfRestricted),
      ...strippedSegments.slice(
        indexOfProperties > -1 ? indexOfProperties : strippedSegments.length,
        strippedSegments.length
      ),
    ];

    indexOfRestricted = strippedSegments.findIndex(isRestrictedPathSegment);
  }

  return strippedSegments;
};

export default function toDataPath($ref) {
  if (!isString($ref)) {
    return null;
  }

  const segments = $ref.split('/');
  const isRoot = segments[0] === '#' || segments[0] === '';
  const startIndex = isRoot ? 1 : 0;
  const strippedSegments = stripSegments(segments);
  const dataPath = strippedSegments
    .slice(startIndex)
    .filter((segment) => segment !== 'properties')
    .map((segment) => jsonPointer.unescape(segment))
    .join('/');

  return isRoot && dataPath.length > 0 ? `/${dataPath}` : dataPath;
}
